import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useGeneralStore = create(
  persist(
    (set) => ({
      folderName: null,
      setFolderName: (name) => set({ folderName: name }),
      clearFlow: () => set({ folderName: null }),
    }),
    {
      name: 'flow-storage',
      getStorage: () => sessionStorage,
    }
  )
);
